import React, { useEffect, useState } from "react";

import { Transition } from "@headlessui/react";
import PropTypes from "prop-types";

import Header from "./Header";
import MessageComposer from "./MessageComposer";

import useVisualViewport from "../../utils/hooks/useVisualViewport";
import { useSDK } from "../../utils/sdk";
import { getBehaviorsSessionStorage } from "../../utils/session-storage";
import { useWebmessenger } from "../../utils/webmessenger";
import Conversation from "../conversation";

function Window({ onMinimze, soundNotification, onToggleSoundNotification }) {
    const { conversation } = useWebmessenger();
    const { emit } = useSDK();
    const [show, setShow] = useState(true);
    const { visualViewport } = useVisualViewport();

    const handleClickOutside = (e) => {
        if (
            e?.target?.className &&
            typeof e.target.className.includes !== "undefined" &&
            e.target.className.includes("ek-chat__mobile")
        ) {
            emit("window:minimized", {
                conversation: conversation?._id || null,
            });
            setShow(false);
        }
    };

    let startY;

    const handleTouchStart = (event) => {
        startY = event.touches[0].clientY;
    };

    const handleTouchMove = (event) => {
        const elem = event.target;

        const ekChatConversationNode = document.getElementsByClassName(
            "ek-chat__conversation"
        )?.[0];
        const ekChatMessageWrapper = document.getElementsByClassName(
            "ek-chat__conversation--wrapper"
        )?.[0];

        const endY = event.touches[0].clientY;

        let preventScrollMessageList = false;

        if (ekChatConversationNode) {
            if (
                !ekChatConversationNode?.contains(elem) ||
                elem.className.includes("ek-chat__conversation--mask")
            ) {
                preventScrollMessageList = true;
            }
        }

        if (ekChatMessageWrapper) {
            if (
                ekChatMessageWrapper.contains(elem) &&
                ekChatMessageWrapper.scrollHeight ===
                    ekChatMessageWrapper.clientHeight
            )
                preventScrollMessageList = true;

            if (
                startY > endY &&
                ekChatMessageWrapper.contains(elem) &&
                ekChatMessageWrapper.scrollHeight >
                    ekChatMessageWrapper.clientHeight &&
                ekChatMessageWrapper.scrollHeight -
                    ekChatMessageWrapper.scrollTop -
                    ekChatMessageWrapper.clientHeight <
                    1
            )
                preventScrollMessageList = true;
        }

        if (preventScrollMessageList) event.preventDefault();
    };

    // const handleScroll = (event) => {
    //     if (document.getElementsByClassName("ek-chat__screen").length > 0 && window.innerWidth <= 769) {
    //         window.scrollTo(0, 0);
    //         event.stopPropagation();
    //     }
    // };

    useEffect(() => {
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("touchmove", handleTouchMove, {
            passive: false,
        });
        document.addEventListener("touchstart", handleTouchStart, {
            passive: false,
        });
        document.addEventListener("scroll", window.eK.handleScroll);

        const storage = getBehaviorsSessionStorage();

        /**
         * Store the behavior message as triggered when window has been open and if there is no conversation yet
         */
        if (
            storage.triggered?.greeting?.message?.behavior &&
            !storage.triggered?.notification?.[
                storage.triggered?.greeting?.message?.behavior
            ]
        ) {
            storage.triggered = {
                ...storage.triggered,
                notification: {
                    ...storage.triggered.notification,
                    [storage.triggered.greeting.message.behavior]: true,
                },
            };

            sessionStorage.setItem("eK-behaviors", JSON.stringify(storage));
        }
        return () => {
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("touchmove", handleTouchMove);
            document.removeEventListener("touchstart", handleTouchStart);
            document.removeEventListener("scroll", window.eK.handleScroll);
        };
    });

    return (
        <Transition
            as="div"
            show={show}
            appear
            className="ek-chat__screen"
            enter="ek-chat__screen--enter"
            entered="ek-chat__screen--entered"
            leave="ek-chat__screen--leave"
            afterLeave={() => {
                onMinimze();
            }}
        >
            <div
                className="ek-chat__mobile"
                style={{
                    height: visualViewport.height,
                }}
            >
                <Transition
                    as="div"
                    show={show}
                    appear
                    className="ek-chat__container"
                    enter="ek-chat__container--enter"
                    entered="ek-chat__container--entered"
                    leave="ek-chat__container--leave"
                    afterLeave={() => {
                        onMinimze();
                    }}
                >
                    <Header
                        onMinimze={() => {
                            setShow(false);
                        }}
                        onToggleSoundNotification={onToggleSoundNotification}
                        soundNotification={soundNotification}
                    />
                    <Conversation />
                    <MessageComposer />
                </Transition>
            </div>
        </Transition>
    );
}

Window.propTypes = {
    onMinimze: PropTypes.func,
    soundNotification: PropTypes.bool,
    onToggleSoundNotification: PropTypes.func,
};

Window.defaultProps = {
    onMinimze: () => {},
    soundNotification: false,
    onToggleSoundNotification: () => {},
};

export default Window;
